import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
            <div className="container">
        <Weather defaultCity="Kyiv" />
      <footer>
          <a
            href="https://github.com/Fresa156/react-weather-app"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://majestic-sprite-069af4.netlify.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            hosted on Netlify
          </a>
          </footer>
    </div>
    </div>
  );
}
